import { useMemo } from "react"

import createStore from "@Stores/base-factories"
import { hookDatasourceList } from "@Stores/base-factories/store-list"
import hookSiteSelectedFactory from "@Stores/base-factories/store-site-selection"

const useDatasourceFactory = ({ fetch, siteSelected: { id: siteId }, collections: { collectionsURL } }) => useMemo(() => ({
  test: async ({ test: query, ...payload }) => await fetch({
    method: 'post',
    url: `${collectionsURL}/test`,
    data: { payload, query },
    params: { siteId },
  }),
}), [collectionsURL, fetch, siteId])

const { Provider, useStore } = createStore()
  .extend(hookSiteSelectedFactory('siteId'))
  .extendHookCollectionFactory('datasource')
  .extendHookCollectionsFactory('datasources')
  .extend(hookDatasourceList())
  .extend(useDatasourceFactory)
  .factory()

export {
  Provider as DatasourceProvider,
  useStore as useDatasourceStore,
}
